import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Column, Grouping } from "@devexpress/dx-react-grid";
import { Table } from "@devexpress/dx-react-grid-material-ui";

import styles from "./OfferContainer.module.scss";
import { OmPageHeader } from "../../common/imports";
import { useParams } from "react-router-dom";
import { useGetOfferByIdQuery } from "../../services/offersApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import WithLoading from "../../components/WithLoading";

const Detail = () => {
    const { offerId } = useParams();

    const getOfferById = useGetOfferByIdQuery(offerId ? offerId : skipToken, {
        refetchOnMountOrArgChange: true,
    });
    return (
        <main className={styles.root}>
            <div style={{ width: "100%" }}>
                <OmPageHeader headerTitle={"Offer Detail: " + offerId} />
            </div>
            <div style={{ width: "100%" }}>
                <WithLoading query={getOfferById}>offer Detail</WithLoading>
            </div>
        </main>
    );
};

export default Detail;
